import { ComponentRef, Injectable, Injector, Type, ViewContainerRef } from '@angular/core';
import { each } from 'lodash-es';

import { CustomDialogContainerComponent } from '../components/custom-dialog-container/custom-dialog-container.component';
import { DialogContainerComponent } from '../components/dialog-container/dialog-container.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  public dialogs: ComponentRef<DialogContainerComponent>[] = [];
  public componentContainer: ViewContainerRef;

  /**
   * Constructor
   *
   * @param {Injector} injector
   */
  public constructor(
    private injector: Injector,
  ) {
  }

  /**
   * Opens the dialog
   *
   * @param {Type<any>} componentChild
   * @param {Object} data
   * @param {string} classes
   * @param {ViewContainerRef} overrideContainer
   * @param {string} type
   * @returns {DialogContainerComponent}
   */
  public open(
    componentChild: Type<any>,
    data: Object,
    classes: string = 'default medium',
    overrideContainer: ViewContainerRef = undefined,
    type: string = 'default',
  ): DialogContainerComponent {

    // Pass a custom container here so that the dialog appears in the view container
    if (overrideContainer !== undefined) {
      this.componentContainer = overrideContainer;
    }

    each(this.dialogs, (dialog) => {
      dialog.destroy();
    });

    const componentType: Type<any> = (type === 'custom' ? CustomDialogContainerComponent : DialogContainerComponent);
    const component = this.componentContainer.createComponent(componentType, {
      injector: this.injector
    });

    component.instance.generate(componentChild, data, classes);
    component.instance.dialogClosed().subscribe(
      () => {
        component.destroy();
      },
    );

    this.dialogs.push(component);
    return component.instance;
  }
}
